import { render, staticRenderFns } from "./CategoryForm.vue?vue&type=template&id=97fbf9d0&scoped=true&"
import script from "./CategoryForm.vue?vue&type=script&lang=ts&"
export * from "./CategoryForm.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryForm.vue?vue&type=style&index=0&id=97fbf9d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fbf9d0",
  null
  
)

export default component.exports